document.addEventListener('DOMContentLoaded', function() {
  const pageId = window.location.pathname;
  
  /* WAKE LOCK */
  const wakeLockToggle = document.getElementById('wakelock-toggle');
  let wakeLock = null;
  if (wakeLockToggle) {
    if (!('wakeLock' in navigator)) console.log('Wake Lock API not supported');
    wakeLockToggle.addEventListener('change', async () => {
      if (wakeLockToggle.checked) {
        try {
          wakeLock = await navigator.wakeLock.request('screen');
        } catch (err) {
          wakeLockToggle.checked = false;
          alert('Din enhed understøtter desværre ikke at holde skærmen tændt.');
        }
      } else {
        if (wakeLock !== null) { await wakeLock.release(); wakeLock = null; }
      }
    });
    document.addEventListener('visibilitychange', async () => {
      if (wakeLock !== null && document.visibilityState === 'visible') {
        wakeLock = await navigator.wakeLock.request('screen');
      }
    });
  }

  /* SERVINGS */
  const wrapper = document.querySelector('.sb-servings-control');
  if (wrapper) {
    const baseServings = parseInt(wrapper.dataset.baseServings, 10) || 4;
    let currentServings = baseServings; 
    const displayEl = wrapper.querySelector('.sb-current-servings');
    const ingredientItems = document.querySelectorAll('.sb-ingredient-item');
    updateIngredientsUI(baseServings, currentServings);
    wrapper.querySelectorAll('.sb-step-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = e.currentTarget.dataset.action;
        if (action === 'increase' && currentServings < 20) currentServings++;
        if (action === 'decrease' && currentServings > 1) currentServings--;
        displayEl.textContent = currentServings;
        updateIngredientsUI(baseServings, currentServings);
      });
    });
    function updateIngredientsUI(base, current) {
      ingredientItems.forEach(item => {
        const originalText = item.dataset.baseLine;
        const newText = scaleIngredientLine(originalText, base, current);
        item.querySelector('.sb-ing-text').innerHTML = newText; 
      });
    }
  }

  /* SCALING */
  function scaleIngredientLine(text, base, current) {
    if (base === current) return text.replace(/(\d+(?:[.,]\d+)?)/, '<b>$1</b>');
    const ratio = current / base;
    const regex = /(?:^|[•\-\*]\s*)(?:(ca\.|cirka|omtrent)\s+)?((?:\d+(?:[.,]\d+)?(?:\s*[\/\-–]\s*\d+(?:[.,]\d+)?)?)|\d+)(?:\s*(x|×))?(?=\s|[a-zA-ZæøåÆØÅ])/i;
    const match = text.match(regex);
    if (!match || text.includes('°C') || text.includes('grader')) return text;
    const fullMatch = match[0];
    const prefix = match[1] || '';
    const quantityStr = match[2];
    const multiplier = match[3] || '';
    let result = quantityStr;
    if (quantityStr.includes('-') || quantityStr.includes('–')) {
      const sep = quantityStr.includes('–') ? '–' : '-';
      const parts = quantityStr.split(sep);
      if (parts.length === 2) {
        const s = parseDanish(parts[0]);
        const e = parseDanish(parts[1]);
        if (!isNaN(s) && !isNaN(e)) result = `${formatDanish(s * ratio)}${sep}${formatDanish(e * ratio)}`;
      }
    } else if (quantityStr.includes('/')) {
      const parts = quantityStr.split('/');
      const val = parseFloat(parts[0]) / parseFloat(parts[1]);
      if (!isNaN(val)) result = formatDanish(val * ratio);
    } else {
      const val = parseDanish(quantityStr);
      if (!isNaN(val)) result = formatDanish(val * ratio);
    }
    return text.replace(fullMatch, `${prefix ? prefix + ' ' : ''}<b>${result}</b>${multiplier ? ' ' + multiplier : ''}`);
  }
  function parseDanish(str) { return parseFloat(str.replace(',', '.').trim()); }
  function formatDanish(num) {
    if (num >= 10) return Math.round(num).toString();
    let f = num.toFixed(1);
    if (f.endsWith('.0')) f = f.slice(0, -2);
    return f.replace('.', ',');
  }

  /* CHECKBOXES */
  const ingredients = document.querySelectorAll('.sb-ingredient-item');
  const ingStorageKey = `sb-ing-done-${pageId}`;
  const savedIng = JSON.parse(localStorage.getItem(ingStorageKey) || '[]');
  ingredients.forEach((ing, index) => {
    if (savedIng.includes(index)) { ing.classList.add('is-done'); ing.querySelector('.sb-ing-checkbox-input').checked = true; }
    ing.addEventListener('click', () => {
      ing.classList.toggle('is-done');
      const isDone = ing.classList.contains('is-done');
      ing.querySelector('.sb-ing-checkbox-input').checked = isDone;
      const currentDone = Array.from(document.querySelectorAll('.sb-ingredient-item.is-done')).map(el => Array.from(ingredients).indexOf(el));
      localStorage.setItem(ingStorageKey, JSON.stringify(currentDone));
    });
  });

  const steps = document.querySelectorAll('.sb-step-item');
  const stepStorageKey = `sb-step-done-${pageId}`;
  const savedStep = JSON.parse(localStorage.getItem(stepStorageKey) || '[]');
  steps.forEach((step, index) => {
    if (savedStep.includes(index)) { step.classList.add('is-done'); step.querySelector('.sb-step-checkbox-input').checked = true; }
    step.addEventListener('click', (e) => {
      if(e.target.tagName === 'A') return;
      step.classList.toggle('is-done');
      const isDone = step.classList.contains('is-done');
      step.querySelector('.sb-step-checkbox-input').checked = isDone;
      const currentDone = Array.from(document.querySelectorAll('.sb-step-item.is-done')).map(el => Array.from(steps).indexOf(el));
      localStorage.setItem(stepStorageKey, JSON.stringify(currentDone));
    });
  });

  /* COPY */
  const copyBtn = document.getElementById('copy-ingredients-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const text = Array.from(document.querySelectorAll('.sb-ingredient-item')).map(li => li.innerText.replace(/[\n\r]+/g, ' ').trim()).join('\n');
      navigator.clipboard.writeText(text).then(() => {
        const fb = document.getElementById('copy-feedback');
        fb.style.display = 'inline';
        setTimeout(() => fb.style.display = 'none', 2000);
      });
    });
  }
});